module.exports = {"roll":{"In":"reveal","Out":"conceal"},"puff":{"In":"drop","Out":"pop"},"zoom":{"In":"expand","Out":"collapse"}}


//////////////////
// WEBPACK FOOTER
// ./js/modules/privates/validations/animations/effectNameMappings.json
// module id = 75
// module chunks = 0 1